import { render, staticRenderFns } from "./SelectionActionsComponent.vue?vue&type=template&id=04f71a9f&scoped=true"
import script from "./SelectionActionsComponent.vue?vue&type=script&lang=js"
export * from "./SelectionActionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f71a9f",
  null
  
)

export default component.exports